import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { plugin, defaultConfig } from '@formkit/vue'
import formkitConfig from '../formkit.config'
import { StatusBar, Style } from '@capacitor/status-bar'
import { Capacitor } from '@capacitor/core'
import VueApp from './App.vue'
import router from './router'
import * as Sentry from '@sentry/vue'
import { supabaseIntegration } from '@supabase/sentry-js-integration'
import { SupabaseClient } from '@supabase/supabase-js'
import i18n from './i18n'
import { createHead } from '@vueuse/head'

const app = createApp(VueApp)
const head = createHead()

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    supabaseIntegration(SupabaseClient, Sentry, { tracing: true, breadcrumbs: true, errors: true }),
    // Sentry.replayIntegration({
    //   maskAllText: false,
    //   blockAllMedia: false
    // })
  ],
  replaysSessionSampleRate: 1.0, // TODO: set to 0.1 for production
  replaysOnErrorSampleRate: 1.0
})

app.use(createPinia())
app.use(router)
app.use(plugin, defaultConfig(formkitConfig()))
app.use(i18n)
app.use(head)

app.mount('#app')

// Display content under transparent status bar only on mobile devices
if (Capacitor.getPlatform() !== 'web') {
  StatusBar.setOverlaysWebView({ overlay: false })
}
